export const isGroupOrderPrepTime = (orderTime) => {
    return orderTime.prepTime !== undefined;
};
export const isGroupOrderTime = (orderTime) => {
    return orderTime.isAdjusted !== undefined;
};
